var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclecheckSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-5 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 60q-54 0-100 27t-73 73-27 100 27 100 73 73 100 27 100-27 73-73 27-100-27-100-73-73-100-27zm-25 309L116 264l36-47 71 85 137-139 36 49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclecheckSvgrepoCom);
export default __webpack_public_path__ + "static/media/circlecheck-svgrepo-com.40d8554156e3a9a9908efed9a48795b1.svg";
export { ForwardRef as ReactComponent };